import gql from 'graphql-tag';

export const SearchUsers: any = gql`
  query($searchText:String!, $internal:Boolean!, $types:[String], $active:Boolean, $createdUserId: ID, $paging: Paging, $labels:[String]) {
    search(
      searchText:$searchText,
       internal:$internal,
        types:$types,
        active:$active,
        createdUserId:
        $createdUserId,
        paging: $paging,
        labels:$labels) 
        {
      _id
      active
      oktaActive
      lastAccessed
      firstName
      lastName
      email
      internal
      discoverAccess
      tenantName
   		info {
        userName
        country {
        code
        name
        }
        company
        phoneNumber
        phoneNumberCountryCode
        workAddress
        department
        clientRole
        title
      }
      account {
        config {
          branding
          appAccess
        }
      }
   	 	applications {
        name
        userType
        defaultTerritory {
          id
          name
          type
        }
        defaultLabel {
          id
          name
          type
        }
        r2SubLabels
        familyLabels {
          id
          name
          type
        }
        followedArtists {
          _id
        }
        followedTracks {
          _id
        }
        accessArtists {
          _id
          name
          image
          genres
          label_families
        }
        subscriptions {
          name
          email
          mobile
        }
        revenueAccess {
          canView
					pending
        }
        active
      }
      environmentTokens {
        name,
        value,
        app,
        platform,
        scope
      }
      restrictedApplicationsAccess {
        id
        features {
          _id
          name
          value
        }
      }
      typeChangedUserId
      acceptedTermsAndConditions
			createdUserId
      typeChangedUser{
          _id
          active
          oktaActive
          lastAccessed
          firstName
          lastName
          email
          internal
          discoverAccess
          applications {
            name
            userType
            defaultTerritory {
              id
              name
              type
            }
            defaultLabel {
              id
              name
              type
            }
            familyLabels {
              id
              name
              type
            }
            followedArtists {
              _id
              name
              image
              genres
              label_families
            }
            accessArtists {
              _id
              name
              image
              genres
              label_families
            }
            subscriptions {
              name
              email
              mobile
            }
            revenueAccess {
              canView
              pending
            }
          active
        }
          info {
            userName
            country {
            code
            name
          }
          company
          phoneNumber
          phoneNumberCountryCode
          workAddress
          department
          clientRole
          title
        }
    }
    revokedByUser {
      _id
      email
    }
    revokedDate
    createdUser{
          _id
          active
          oktaActive
          lastAccessed
          firstName
          lastName
          email
          internal
          discoverAccess
          applications {
            name
            userType
            defaultTerritory {
              id
              name
              type
            }
            defaultLabel {
              id
              name
              type
            }
            familyLabels {
              id
              name
              type
            }
            followedArtists {
              _id
              name
              image
              genres
              label_families
            }
            accessArtists {
              _id
              name
              image
              genres
              label_families
            }
            subscriptions {
              name
              email
              mobile
            }
            revenueAccess {
              canView
              pending
            }
          active
        }
          info {
            userName
            country {
            code
            name
          }
          company
          phoneNumber
          phoneNumberCountryCode
          workAddress
          department
          clientRole
          title
        }
    }
      
     
    
    }
  }
`;

export const getNonInviteAcceptedUsers: any = gql`
  query getNonInviteAcceptedUsers{
    getNonInviteAcceptedUsers {
    count
    lastUserId
    tenantName
    usersMapping {
      id
      email
    }
    users {
      _id
    	active
      lastAccessed
      firstName
      lastName
      email
      internal
      discoverAccess
      tenantName
   		info {
        userName
        country {
        code
        name
        }
        company
        phoneNumber
        phoneNumberCountryCode
        workAddress
        department
        clientRole
        title
      }
      account {
        config {
          branding
          appAccess
        }
      }
   	 	applications {
        name
        userType
        defaultTerritory {
          id
          name
          type
        }
        defaultLabel {
          id
          name
          type
        }
        familyLabels {
          id
          name
          type
        }
        followedArtists {
          _id
          name
          image
          genres
          label_families
        }
        accessArtists {
          _id
          name
          image
          genres
          label_families
        }
        subscriptions {
          name
          email
          mobile
        }
        revenueAccess {
          canView
					pending
        }
        active
      }
      environmentTokens {
        name,
        value,
        app,
        platform,
        scope
      }
      restrictedApplicationsAccess {
        id
        features {
          _id
          name
          value
        }
      }
      typeChangedUserId
      acceptedTermsAndConditions
			createdUserId
      createdAt
      }
    }
  }
`;


export const GetUserQuery: any = gql`
  query user($ID:ID!){
    user(_id:$ID) {
      _id
      email
      firstName
      lastName
      active
      internal
      externalInfo {
        country
        company
        clientType
        phoneNumber
        defaultLabel {
          id
          name
          type
        }
      }
      internalInfo {
        country
        company
        defaultLabel {
          id
          name
          type
        }
      }
    }
  }
`;

export const loadAllRequests: any = gql`
  query($paging: Paging) {
    loadAllRequests(paging: $paging) {
      _id
      firstName
      lastName
      email
      company
      country {
        code
        name
      }
      phoneNumber
      labels {
        id
        name
        type
      }
      accessArtists {
        _id
        name
        image
        genres
        label_families
      }
      comments
      createdAt
    }
  }
`;

export const NewUser: any = gql`
  mutation createUser($UserInput:UserInput){
    createUser(input:$UserInput){_id}
  }
`;

export const UpdateUser: any = gql`
  mutation updateUser($ID:ID!, $UserInput:UserInput){
    updateUser(_id: $ID, input:$UserInput)
  }
`;

export const checkUserQuery: any = gql`
  query checkUserExists($email:String!){
    checkUserExists(email:$email) 
  }
`;

export const getSubLabels: any = gql`
  query getSubLabels($labelName: String!) {
    getSubLabels(labelName: $labelName) {
      id
      name
    }
  }
`;

export const deActivateUser: any = gql `
  mutation deactivateUser($email: String!, $revokedByUserId: String!, $revokedDate: Date) {
    removeUserFromGroup(email: $email, revokedByUserId: $revokedByUserId, revokedDate: $revokedDate)
  }
`;

export const activateUser: any = gql `
  mutation activateUser($email: String!) {
    addUserToGroup(email: $email)
  }
`;

export const createRequest: any = gql `
  mutation createRequest($request: RequestInput!) {
    createRequest(request: $request)
  }
`;

export const deleteRequest: any = gql `
  mutation deleteRequest($id: ID!) {
    deleteRequest(id: $id)
  }
`;

export const setFamilyLabels: any = gql `
  mutation setFamilyLabels($id: ID!, $applicationName: String!, $familyLabels:[LabelInfoInput]) {
    setFamilyLabels(userId: $id, applicationName: $applicationName, familyLabels: $familyLabels)
  }
`;

export const resetUserPassword: any = gql `
  mutation resetUserPassword($email: String!) {
    resetUserPassword(email: $email)
  }
`;

export const resendActivation: any = gql `
  mutation resendActivation($email: String!) {
    resendActivation(email: $email)
  }
`;

export const deleteUser: any = gql `
  mutation deleteUser($id: ID!, $email: String!) {
    deleteUser(id: $id, email: $email)
  }
`;

export const transferRole: any = gql `
  mutation transferRole($fromUserId: ID!, $toUserId: ID!, $role: String!, $applicationName: String!) {
    transferRole(fromUserId: $fromUserId,  toUserId:  $toUserId, role: $role, applicationName: $applicationName )
  }
`;

export const createUserByEmailFromADFS: any = gql `
  mutation createUserByEmailFromADFS($email: String!, $app: String!, $type: String!) {
    createUserByEmailFromADFS(email: $email, app: $app, type: $type){
    _id
    	active
      lastAccessed
      firstName
      lastName
      email
      internal
      discoverAccess
   		info {
        userName
        country {
        code
        name
        }
        company
        phoneNumber
        phoneNumberCountryCode
        workAddress
        department
        clientRole
        title
      }
   	 	applications {
        name
        userType
        defaultTerritory {
          id
          name
          type
        }
        defaultLabel {
          id
          name
          type
        }
        familyLabels {
          id
          name
          type
        }
        followedArtists {
          _id
          name
          image
          genres
          label_families
        }
        accessArtists {
          _id
          name
          image
          genres
          label_families
        }
        subscriptions {
          name
          email
          mobile
        }
        revenueAccess {
          canView
					pending
        }
        active
      }
      environmentTokens {
        name,
        value,
        app,
        platform,
        scope
      }
      restrictedApplicationsAccess {
        id
        features {
          _id
          name
          value
        }
      }
      typeChangedUserId
      acceptedTermsAndConditions
			createdUserId
    }
    }
`;

export const getUserFromToken: any = gql`
  query getUserFromToken($token:String!, $app: String!){
    getUserFromToken(token:$token, app:$app) {
      _id
    	active
      lastAccessed
      firstName
      lastName
      email
      internal
      discoverAccess
   		info {
        userName
        country {
        code
        name
        }
        company
        phoneNumber
        phoneNumberCountryCode
        workAddress
        department
        clientRole
        title
      }
      account {
        config {
          branding
          appAccess
        }
      }
   	 	applications {
        name
        userType
        defaultTerritory {
          id
          name
          type
        }
        defaultLabel {
          id
          name
          type
        }
        familyLabels {
          id
          name
          type
        }
        followedArtists {
          _id
          name
          image
          genres
          label_families
        }
        accessArtists {
          _id
          name
          image
          genres
          label_families
        }
        subscriptions {
          name
          email
          mobile
        }
        revenueAccess {
          canView
					pending
        }
        active
      }
      environmentTokens {
        name,
        value,
        app,
        platform,
        scope
      }
      restrictedApplicationsAccess {
        id
        features {
          _id
          name
          value
        }
      }
      typeChangedUserId
      acceptedTermsAndConditions
			createdUserId
      }
    }
`;

export const assignUserType: any = gql `
  mutation assignUserType($assignerId: ID!, $assigneeId: ID!, $app: String!, $type: String) {
    assignUserType(assignerId: $assignerId,  assigneeId:  $assigneeId, app: $app, type: $type)
  }
`;





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./src/app/queries/users.model.ts